import React from 'react';
import { Switch, Route, BrowserRouter, Redirect } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';
import PrivateRoutes from './PrivateRoutes';
import Login from '../views/auth/Login';
import CspLaunchHandler from '../views/auth/CspLaunchHandler';
import Error404 from './Error404';
import { hasSession } from '../helper';
import TooManyIPs from "views/auth/TooManyIPs";
import VerifyIdentity from 'views/auth/VerifyIdentity';
import ResetSecurityQuestions from 'views/auth/ResetSecurityQuestions';
import config from 'config';

interface Props {}

const RouterPath: React.FC<Props> = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Signup For backward compatibility - redirect to CSP */}
        <Route
          exact
          path="/users/sign_up"
          render={() => {
            window.location.href = config.csp_signup_url;
            return null;
          }}
        />
        <Route path="/login">
          {hasSession() ? <Redirect to="/" /> : <Login />}
        </Route>
        {/* Redirect old signup to CSP */}
        <Route
          path="/signup"
          render={() => {
            window.location.href = config.csp_signup_url;
            return null;
          }}
        />
        {/* CSP Launch Token Handler */}
        <Route path="/auth/token">
          <CspLaunchHandler />
        </Route>
        {/* CSP Import Handler (same flow — validates code, imports species if payload present) */}
        <Route path="/import/csp">
          <CspLaunchHandler />
        </Route>
        {/* Security layer routes - still needed */}
        <Route path="/verifyIdentity">
          <VerifyIdentity />
        </Route>
        <Route path="/error_too_many_ip">
          <TooManyIPs />
        </Route>
        <Route path="/reset_security_questions">
          <ResetSecurityQuestions />
        </Route>
        {/* Redirect old auth routes to CSP */}
        <Route
          path="/forgot_password"
          render={() => {
            window.location.href = config.csp_login_url;
            return null;
          }}
        />
        <Route
          path="/reset_password"
          render={() => {
            window.location.href = config.csp_login_url;
            return null;
          }}
        />
        <Route
          path="/confirm"
          render={() => {
            window.location.href = config.csp_login_url;
            return null;
          }}
        />
        <Route
          path="/resend_confirmation"
          render={() => {
            window.location.href = config.csp_login_url;
            return null;
          }}
        />
        <PrivateRoutes path="/" component={ProtectedRoutes} />

        <Route component={Error404} />
      </Switch>
    </BrowserRouter>
  );
};

export default RouterPath;
